"use strict";
var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        if (typeof b !== "function" && b !== null)
            throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    Object.defineProperty(o, k2, { enumerable: true, get: function() { return m[k]; } });
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.GKToolbar = void 0;
var React = __importStar(require("react"));
var __1 = require("..");
var models_1 = require("../../models");
var ResponsiveService_1 = require("../../services/ResponsiveService");
var common_1 = require("../../common");
require("./GKToolbar.css");
var GKToolbarMenu_1 = require("./GKToolbarMenu/GKToolbarMenu");
var GKToolbarSelect_1 = require("./GKToolbarSelect/GKToolbarSelect");
var isSelect = function (item) {
    return item.selectItems !== undefined;
};
var isMenu = function (item) {
    return item.menuItems !== undefined;
};
var GKToolbar = /** @class */ (function (_super) {
    __extends(GKToolbar, _super);
    function GKToolbar(props) {
        var _this = _super.call(this, props) || this;
        _this.updateCurrentOrientation = function (result) {
            _this.setState({ currentOrientation: result });
        };
        _this.state = {
            currentOrientation: undefined,
        };
        return _this;
    }
    GKToolbar.prototype.componentDidMount = function () {
        this.registerListener();
    };
    GKToolbar.prototype.componentWillUnmount = function () {
        this.unregisterListener();
    };
    GKToolbar.prototype.componentDidUpdate = function (prevProps) {
        if (this.props.orientation !== prevProps.orientation) {
            this.unregisterListener();
            this.registerListener();
        }
    };
    GKToolbar.prototype.render = function () {
        var _this = this;
        var _a = this.props, 
        // Intentionally destructured from otherProps
        // eslint-disable-next-line @typescript-eslint/no-unused-vars
        actions = _a.actions, label = _a.label, 
        // Intentionally destructured from otherProps
        // eslint-disable-next-line @typescript-eslint/no-unused-vars
        orientation = _a.orientation, size = _a.size, tooltipsPlacement = _a.tooltipsPlacement, otherProps = __rest(_a, ["actions", "label", "orientation", "size", "tooltipsPlacement"]);
        return (React.createElement("div", __assign({}, (0, common_1.mapDefaultProps)(otherProps, { _gkComponentName: "gk-toolbar" })),
            label && (React.createElement("h5", { className: "gk-toolbar-label mb-2 text-center text-nowrap" }, label)),
            React.createElement(__1.GKButtonGroup, { vertical: this.state.currentOrientation === models_1.Orientation.Vertical }, this.props.actions.map(function (action, i) {
                var content;
                if (isMenu(action)) {
                    content = (React.createElement(GKToolbarMenu_1.GKToolbarMenu, __assign({}, action, { key: _this.uniqueId + "-" + i, className: "gk-toolbar-action" })));
                }
                else if (isSelect(action)) {
                    content = (React.createElement(GKToolbarSelect_1.GKToolbarSelect, __assign({}, action, { key: _this.uniqueId + "-" + i, className: "gk-toolbar-action" })));
                }
                else {
                    content = (React.createElement(__1.GKButton, __assign({ className: "gk-toolbar-action", color: "primary", key: _this.uniqueId + "-" + i, size: size || "md", tooltipPlacement: tooltipsPlacement }, action)));
                }
                return content;
            }))));
    };
    GKToolbar.prototype.registerListener = function () {
        if (this.props.orientation) {
            this.unregistrationToken = ResponsiveService_1.responsiveService.registerListener(this.props.orientation, this.updateCurrentOrientation);
        }
    };
    GKToolbar.prototype.unregisterListener = function () {
        if (this.unregistrationToken) {
            this.unregistrationToken.unregister();
        }
    };
    return GKToolbar;
}(common_1.GKPureComponent));
exports.GKToolbar = GKToolbar;
